import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const ForgotPasswordRequestDtoSchema = z.object({
  email: z.email(),
});

const ForgotPasswordResponseDtoSchema = z.object({
  emailSentAt: z.string(),
});

export type ForgotPasswordRequestDto = z.infer<
  typeof ForgotPasswordRequestDtoSchema
>;
export type ForgotPasswordResponseDto = z.infer<
  typeof ForgotPasswordResponseDtoSchema
>;

export const forgotPassword = (
  dto: ForgotPasswordRequestDto,
  config?: AxiosRequestConfig<ForgotPasswordRequestDto>
) => {
  const data = ForgotPasswordRequestDtoSchema.parse(dto);
  return api
    .post('/auth/forgot-password', data, config)
    .then(responseContract(ForgotPasswordResponseDtoSchema));
};
